var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ rtl: _vm.isRtl }},[_c('v-main',[_c(_vm.layout,{tag:"component"})],1),_c('portal-target',{attrs:{"name":"slide-out-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }